import React, { useState, useContext } from "react";
import axios from "axios";
import { API_BASE_URL, API_KEY } from "../../../config/config";
import { AuthContext } from "../../../context/authContext";
import qs from "qs";
import Post from "../../Post/Post";
import UserAvatar from "../../common/UserAvatar";
import {ThreadContext} from "../../../context/threadContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronUp, faExpandArrowsAlt, faReply} from "@fortawesome/free-solid-svg-icons";
import {t} from "i18next";

const ReplyFormTemplate = ({ thread, templates }) => {
	const { visitor } = useContext(AuthContext);

	const {newReplies, loadMoreNewReplies} = useContext(ThreadContext);

	const [selectedTemplateId, setSelectedTemplateId] = useState('');
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [error, setError] = useState('');

	const handleTemplateChange = (event) => {
		setSelectedTemplateId(event.target.value);
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		setIsSubmitting(true);
		setError('');

		const selectedTemplate = templates.find(template => template.template_id === parseInt(selectedTemplateId));

		if (!selectedTemplate) {
			setError(t('please_select_valid_reply_template'));
			setIsSubmitting(false);
			return;
		}

		try {
			let data = qs.stringify({
				'thread_id': thread.thread_id,
				'template_id': selectedTemplate.template_id,
			});

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${API_BASE_URL}/posts/template`,
				headers: {
					'XF-Api-Key': API_KEY,
					'XF-Api-User': visitor.user_id,
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				data: data,
				withCredentials: true
			};

			const response = await axios.request(config);
			let post = response.data.post;

			loadMoreNewReplies(post);

			setSelectedTemplateId('');
		} catch (error) {
			console.error('Failed to post reply:', error);
			setError('Failed to post reply. Please try again.');
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<div>
			{newReplies && newReplies.length > 0 && (
				<div>
					{newReplies.map((post, index) => (
						<div className="mb-4" key={index}>
							<Post thread={thread} post={post} postId={post.post_id}/>
						</div>
					))}
				</div>
			)}

			<div>
				<div className="block-minorHeader">
					Bình luận vào bài viết này
				</div>

				<div className="mt-2 border border-borderColor flex rounded-lg">
					<div
						className="w-auto flex gap-x-2 bg-primary bg-opacity-85 p-2 flex-shrink-0 flex-grow-0 text-center lg:block lg:w-[160px]">
						<a href={visitor.view_url} title={visitor.username}
						   className="block w-[48px] h-[48px] mb-2 lg:mx-auto lg:w-[96px] lg:h-[96px]">
							<UserAvatar user={visitor}/>
						</a>
					</div>

					<div className="flex-1 p-1 min-w-0 lg:p-4">
						<div className="flex flex-col h-full">
							<div className="text-white text-sm">
								Bạn chỉ có thể bình luận theo các lựa chọn.
								Bình luận tự do chỉ dành cho các thành viên từ nhóm VIp trở lên.
								Nếu bạn muốn tố cáo hàng lởm thì vào box tòa án kỹ nữ việt.
								BQT khuyến khích các bạn viết reviews tại box <b>Reviews Gái Gọi</b>.
							</div>

							<form onSubmit={handleSubmit} className="reply-form max-w-sm">
								<div className="form-group">
									<select
										id="replyTemplate"
										value={selectedTemplateId}
										onChange={handleTemplateChange}
										className="form-control block w-full p-2 mb-6 text-sm text-white border border-borderColor rounded-lg bg-primary focus:ring-primary focus:ring-opacity-85 focus:border-primary focus:border-opacity-85"
										disabled={isSubmitting}
									>
										<option value="">Chọn một mẫu bình luận...</option>
										{templates.map(template => (
											<option key={template.template_id} value={template.template_id}>
												{template.message}
											</option>
										))}
									</select>
								</div>

								{error && <p className="mt-2 error text-red-500 font-bold text-sm">{error}</p>}

								<div className="mt-2 flex flex-wrap items-center gap-2">
									<button type="submit" className="flex-1 button bg-secondary"
									        disabled={isSubmitting}>
										<FontAwesomeIcon icon={faReply} className="mr-2"/>
										{isSubmitting ? 'Loading...' : 'Bình luận'}
									</button>

									{thread.can_bump && (
										<a href={`${thread.view_url}bump-manual`} className="flex-1 button button--cta">
											<FontAwesomeIcon icon={faChevronUp} className="mr-2"/>
											Đẩy bài viết (Bump)
										</a>
									)}
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ReplyFormTemplate;
